var sliders = {
	options: {
		//sliders_instances: [],
	},

  selectors: {
    reviewsSlider: '.js-sliders-reviews',
		reviewsSliderNavButton: '.js-sliders-reviews-nav-button',
  },

	init: function () {
		var self = this;

		//Homepage
		self.reviewsSlider();
	},

	reviewsSlider: function () {
    const self = this;

		if (!jQuery(self.selectors.reviewsSlider).length) {
			return false;
		}

		let slider;

		jQuery(self.selectors.reviewsSlider).each(function () {
			slider = tns({
				container: this,
				items: 1,
				slideBy: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: false,
				nav: true,
				gutter: 0,
				speed: 700,
			});
		});

		jQuery(self.selectors.reviewsSliderNavButton).on('click', function (e) {
			e.preventDefault();

			if (jQuery(this).data('controls') === 'prev') {
				slider.goTo('prev');
			} else {
				slider.goTo('next');
			}
		});
	},
};

export { sliders };
